import { mergeAttributes, Node } from '@tiptap/core'
import { omit } from 'lodash-es'

export const DocumentReferenceNode = Node.create({
  name: 'document-reference',
  group: 'block',
  addAttributes() {
    return {
      reference: {
        default: null,
        parseHTML: (element: HTMLElement) =>
          element.getAttribute('data-reference'),
        renderHTML: (attributes: Record<string, string>) =>
          attributes.reference
            ? { 'data-reference': attributes.reference }
            : {},
      },
      display: {
        default: null,
        parseHTML: (element: HTMLElement) => element.textContent,
      },
    }
  },
  parseHTML() {
    return [{ tag: `a[data-type="${this.name}"]` }]
  },
  renderHTML({ HTMLAttributes }) {
    const display = HTMLAttributes.display
    return [
      'a',
      mergeAttributes(
        { 'data-type': this.name },
        omit(HTMLAttributes, 'display')
      ),
      ...(display ? [display] : []),
    ]
  },
})
